import React, { createContext, useState, useEffect, useContext } from "react";
import Cookies from "js-cookie";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // Mobile detection
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Theme state
  const [darkTheme, setDarkTheme] = useState(() => {
    const savedTheme = Cookies.get("app-theme");
    return savedTheme === 'dark';
  });

  const toggleTheme = () => {
    const newTheme = !darkTheme;
    setDarkTheme(newTheme);
    Cookies.set("app-theme", newTheme ? 'dark' : 'light', { expires: 365 });
  };

  // Sidebar state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setSidebarCollapsed(true);
    }
  }, [isMobile]);

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileDrawerVisible(!mobileDrawerVisible);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <ThemeContext.Provider value={{
      isMobile,
      darkTheme,
      toggleTheme,
      sidebarCollapsed,
      setSidebarCollapsed,
      mobileDrawerVisible,
      setMobileDrawerVisible,
      toggleSidebar
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);